// extracted by mini-css-extract-plugin
export default {"containerButton":"styles-scoped__containerButton--uNMRW"};